<template>
  <Navbar />
  <div class="page-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 py-3 wow fadeInUp">
          <h2 class="title-section">Contact information</h2>
          <div class="divider"></div>

          <ul class="contact-list">
            <li>
              <div class="icon"><span class="mai-mail"></span></div>
              <div class="content">
                <a href="#">adrien.nicolas511@gmail.com</a>
              </div>
            </li>
            <li>
              <div class="icon"><span class="mai-phone-portrait"></span></div>
              <div class="content"><a href="#">+33677464496</a></div>
            </li>
            <li>
              <div class="icon"><i class="fa-brands fa-linkedin"></i></div>
              <div class="content"><a target="_blank" href="https://www.linkedin.com/in/adrien-nicolas-3a84461b1/">My Linkedin Profile</a></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- .container -->
  </div>
  <Footer />
</template>

<script>
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";

export default {
  name: "Contact",

  components: {
    Navbar: Navbar,
    Footer: Footer,
  },
};
</script>

<style></style>
